"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_CRITERIA_TYPES = exports.MANAGE_ACTIONS = exports.INCREMENTABLE_PROPERTIES = exports.RESERVED_PROPERTIES = exports.USER_TYPES = exports.PRODUCT_MAP = exports.SESSION_TIMEOUT_MINUTES = exports.EVENT_TYPES = void 0;
var EVENT_TYPES = {
  Navigate: 'Navigate',
  Download: 'Download',
  View: 'View',
  Engage: 'Engage',
  Search: 'Search',
  Manage: 'Manage',
  Video: 'Video',
  Registration: 'Registration in Progress'
};
exports.EVENT_TYPES = EVENT_TYPES;
var SESSION_TIMEOUT_MINUTES = 15;
exports.SESSION_TIMEOUT_MINUTES = SESSION_TIMEOUT_MINUTES;
var PRODUCT_MAP = {
  'purchaseintelligence.mintel.com': 'Purchase Intelligence',
  'dev-tulsa-gnpd-app01.chicago.mintel.ad:59744': 'The Greatest Dev Site Ever',
  'clients.mintel.com': 'Clients',
  'academic.mintel.com': 'Academic',
  'reports.mintel.com': 'Reports',
  'gnpd.com': 'GNPD',
  'comperemedia.com': 'Comperemedia',
  'marketsizes.mintel.com': 'Market Sizes',
  'menuinsights.com': 'Menu Insights',
  'portal.mintel.com': 'Portal',
  'omni.comperemedia.com': 'Comperemedia Omni',
  'mintel.com': 'Mintel.com'
};
exports.PRODUCT_MAP = PRODUCT_MAP;
var USER_TYPES = {
  registered: 'Registered',
  anonymous: 'Anonymous'
};
exports.USER_TYPES = USER_TYPES;
var RESERVED_PROPERTIES = ['Event Type', 'Mintel Destination'];
exports.RESERVED_PROPERTIES = RESERVED_PROPERTIES;
var INCREMENTABLE_PROPERTIES = ['Number of Shares', 'Number of Adds to Presentation', 'Number of Favorites'];
exports.INCREMENTABLE_PROPERTIES = INCREMENTABLE_PROPERTIES;
var MANAGE_ACTIONS = ['Add', 'Optin', 'Optout', 'Remove', 'Edit', 'Switch'];
exports.MANAGE_ACTIONS = MANAGE_ACTIONS;
var SEARCH_CRITERIA_TYPES = ['Filter', 'Keyword', 'Mixed', 'Other'];
exports.SEARCH_CRITERIA_TYPES = SEARCH_CRITERIA_TYPES;